import type {LevelGeometryDocument} from "@/dungeons/model/DungeonGeometry.ts";

export type UnifiedEditorTool = "calibrate" | "origin" | "select" | "wall" | "door" | "transition" | "annotation" | "light";

export const editorToolLabels: Record<UnifiedEditorTool, string> = {
    select: "Auswahl",
    wall: "Wand",
    door: "Tür",
    transition: "Level-Übergang",
    annotation: "Annotation",
    light: "Licht",
    calibrate: "Grid kalibrieren",
    origin: "Ursprung setzen",
};

export function availableEditorTools(geometry: LevelGeometryDocument): UnifiedEditorTool[] {
    return geometry.registration.calibrated
        ? ["select", "wall", "door", "transition", "annotation", "light", "calibrate", "origin"]
        : ["calibrate"];
}

export function activeEditorTool(tool: UnifiedEditorTool, geometry: LevelGeometryDocument): UnifiedEditorTool {
    return geometry.registration.calibrated ? tool : "calibrate";
}
